import { useTranslation } from 'react-i18next';

/**
 * Skip Link Component for Accessibility
 *
 * Allows keyboard users to skip to main content.
 * Must be the first focusable element on the page.
 */
export function SkipLink() {
  const { t } = useTranslation();

  return (
    <a
      href="#main-content"
      className="skip-link"
    >
      {t('aria.skipToContent')}
    </a>
  );
}
